var map = {
	"./2. Large Chicken Shawarma Sandwich_carousel.webp": 1335,
	"./2. Large Meat Sandwich_carousel.webp": 3716,
	"./4. Chicken Sandwich Samoon Bread with Cheese_carousel .webp": 194,
	"./Dose Spicy burger_carousel.webp": 2568,
	"./arabic chicken shawarma box with french fries.webp": 8160,
	"./arabic meat shawarma box with french fries.webp": 9314,
	"./arabic shawarma chicken with french fries.webp": 5623,
	"./resturant_view_carousel_1.webp": 7000,
	"./resturant_view_carousel_2.webp": 5925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6733;